import { GetUsersBirthdaysResponseItemDto } from '@src/api';
import { OrganisationUI, PollUI, UserUI } from '@src/models';
import { PageListItemType } from '@src/app/modules/pages';

export type ListMode = 'single' | 'multiple';
export type ListType = GetUsersBirthdaysResponseItemDto | UserUI | PageListItemType | OrganisationUI | PollUI;

export type ActionTypes = 'delete' | 'subscribe' | 'unsubscribe' | 'send' | 'link';
export interface ListActionType {
  type: ActionTypes;
  icon?: string;
  title?: string;
  isVisible?: (item: ListType) => boolean; // TODO: заменить на тип Observable<boolean>
  clickCallback: (item?: ListType) => void;
}

export interface GroupedListType {
  title: string;
  items: ListType[];
}
